var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useLang } from '../hooks/use-lang';
import { EntityValue, EntityValueDefaultProps } from './entity-value';
import { useComponentProps } from '../context/component-props-context';
var cls = classNames('person-value');
export var PersonValueDefaultProps = __assign(__assign({}, EntityValueDefaultProps), {
  showOrganisation: true,
  showPosition: true,
  showLabel: false
});
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var SubtitleStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-weight: 300;\n    margin: 0;\n    line-height: 1.25em;\n    margin-top: ", ";\n  "], ["\n    font-weight: 300;\n    margin: 0;\n    line-height: 1.25em;\n    margin-top: ", ";\n  "])), theme.UNIT(1))
});
var SubHeadingStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n  "], ["\n    ", ";\n  "])), SubtitleStyles)
});
// -------- Components -------->
var My = {
  NAME: 'PersonValue',
  Container: styled(EntityValue)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Subtitle: styled.h4(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), SubtitleStyles),
  SubHeading: styled.h4(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), SubHeadingStyles)
};
export var PersonValue = function (props) {
  var componentProps = useComponentProps(My.NAME, PersonValueDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    entity = componentProps.entity,
    showPosition = componentProps.showPosition,
    showOrganisation = componentProps.showOrganisation,
    rest = __rest(componentProps, ["className", "children", "entity", "showPosition", "showOrganisation"]);
  var position = entity.position,
    organisation = entity.organisation;
  var hasPosition = !!position;
  var hasOrganisation = !!organisation;
  var t = useLang();
  return React.createElement(My.Container, __assign({
    entity: entity,
    className: cls.name(className),
    variant: 'person'
  }, rest, {
    meta: React.createElement(React.Fragment, null, showPosition && hasPosition && React.createElement(My.Subtitle, null, t(position)), showOrganisation && hasOrganisation && React.createElement(My.SubHeading, null, t(organisation === null || organisation === void 0 ? void 0 : organisation.name)))
  }), children);
};
PersonValue.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;